import { useEffect, useState } from "react";
import {  ProgressBar } from "react-bootstrap";
import VideoUploaded from './videoUploaded'
import UploadSpinner from "lib/uploadSpinner";

const VideoProgress = (props) => {
  const { fileName,fileSize,cancelClick,removeFiles,uploaded,error,isEditable,is_disabled,selectedData,autofill,remove_disabled,isDisabLed,previewImage,liveness } = props;
  let [completed, setCompleted] = useState(0);

  useEffect(() => {
    setInterval(() => {
      if (completed < 100) {
        setCompleted((completed += 4));
      }
    }, 150);
  }, []);


  const removeUploadedFile = () => {
    removeFiles();
    setCompleted(0);
  }

  const previewUploadedImage = () => {
    previewImage();
  }

  if(uploaded){
    return (
      <VideoUploaded selectedData={selectedData} is_disabled={autofill ? true : is_disabled} fileName={fileName} fileSize={fileSize} removeUploadedFile={removeUploadedFile} error={error} isEditable={isEditable} remove_disabled={remove_disabled} isDisabLed={isDisabLed} previewImage={previewUploadedImage} liveness={liveness}/>
    )
  }
  



  return (
    <>
    {completed !==100 || remove_disabled ?(
     
    <UploadSpinner/>
    ):(
        <VideoUploaded selectedData={selectedData} is_disabled={autofill ? true : is_disabled} fileName={fileName} fileSize={fileSize} error={error} removeUploadedFile={removeUploadedFile} remove_disabled={remove_disabled} previewImage={previewUploadedImage} liveness={liveness}/>
    )}
    </>
  );
};

export default VideoProgress;
